import {LimitOffsetPagination} from '@/api/paginatedResults';

export type AdminData = {
  column_map: {[key: string]: string};
  _meta: {
    update_url: string;
    column_property: string;
    row_property: string;
    type_property?: string;
    readonly?: boolean;
  };
  items: any[];
  title: string;
};

export type PaginatedAdmin = LimitOffsetPagination<AdminData>;

export type AdminGroup = {
  [key: string]: PaginatedAdmin;
};

export const useAdminStore = defineStore('admin', {
  state: () => ({
    admin: {} as AdminGroup,
  }),
  actions: {
    /**
     * TODO: Tidy this store's actions
     */
    setAdmin(name: string, admin: PaginatedAdmin) {
      this.admin[`${name}`] = admin;
    },
    async readAdminEndpoint(name: string, endpoint: string): Promise<[] | undefined> {
      try {
        const {data} = await apiGetAdmin(endpoint);
        this.setAdmin(name, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async createMatrixObject(
      group: string,
      columnId: string,
      rowId: string,
      object_type: string,
    ): Promise<void> {
      try {
        if (this.admin !== null) {
          let url = this.admin[group].results._meta.update_url;
          if (this.admin[group].results._meta.type_property && object_type !== null) {
            url = url.replace(
              this.admin[group].results._meta?.type_property as string,
              object_type.toString(),
            );
          }
          const cId = columnId.split('_').pop() as string;
          const rId = rowId.split('_').pop() as string;
          url = url.replace(this.admin[group].results._meta.column_property, cId.toString());
          url = url.replace(this.admin[group].results._meta.row_property, rId.toString());
          await apiPostAdmin(url);
          const index = this.admin[group].results.items.findIndex((p) => p.id === rowId);
          if (index >= 0) {
            this.admin[group].results.items[index][columnId] = true;
            // Don't toggle all children, the BE does not add permissions recursively
          }
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async removeMatrixObject(
      group: string,
      columnId: string,
      rowId: string,
      object_type: string,
    ): Promise<void> {
      try {
        if (this.admin !== null) {
          let url = this.admin[group].results._meta.update_url;
          if (this.admin[group].results._meta.type_property && object_type !== null) {
            url = url.replace(
              this.admin[group].results._meta.type_property as string,
              object_type.toString(),
            );
          }
          const cId = columnId.split('_').pop() as string;
          const rId = rowId.split('_').pop() as string;
          url = url.replace(this.admin[group].results._meta.column_property, cId.toString());
          url = url.replace(this.admin[group].results._meta.row_property, rId.toString());
          await apiDeleteAdmin(url);
          const index = this.admin[group].results.items.findIndex((p) => p.id === rowId);
          if (index >= 0) {
            this.admin[group].results.items[index][columnId] = false;
          }
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
